import styled from 'styled-components';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Introduction1 = () => {
    useEffect(() => {
        AOS.init({
            duration: 800,
            offset: 0,
        });
    }, []);

    return (
        <Wrap className='rel'>
            <div className="con flex jcsb aic rel">
                <span className="bg-img-1 bg-img img-box abs zi1">
                    <img src="./img/Introduction1_text_1.svg" alt="" data-aos="fade" data-aos-delay="300"/>
                </span>
                <span className="bg-img-2 bg-img img-box abs zi1">
                    <img src="./img/Introduction1_text_2.svg" alt="" data-aos="fade" data-aos-delay="300"/>
                </span>
                <LeftBox className='rel zi2' data-aos="fade-right" data-aos-delay="600">
                    <h1 className='tb'><span className='inblock tb'>스마트폰</span> 하나로<br/>10초만에<br/>인증시스템 도입</h1>
                    <p className='tm'>PASS앱을 통한 빠른 발급 시스템 구축.</p>
                </LeftBox>
                <RightBox className='rel zi2' data-aos="fade-left" data-aos-delay="1000">
                    <div className='list-box flex aic'>
                        <ul className='flex fdc'>
                            <li className='list-1'>
                                <h3 className='tb'>협회 증명서</h3>
                                <p>공인된 협회의 구성원들을 관리하며 인증 체계를 제공합니다.</p>
                                <span className="img-box">
                                    <img src="./img/Introduction1_img_1.svg" alt="" />
                                </span>
                            </li>
                        </ul>
                        <ul className='flex fdc'>
                            <li className='list-2'>
                                <h3 className='tb'>출입 증명서</h3>
                                <p>제한된 지역, 공간에 인증된 사람의 관리를 제공합니다.</p>
                                <span className="img-box">
                                    <img src="./img/Introduction1_img_2.svg" alt="" />
                                </span>
                            </li>
                            <li className='list-3'>
                                <h3 className='tb'>안전 증명서</h3>
                                <p>건축물, 식품 등 공인된 기관과 연계하여 증명서 발급, 제출까지 연계 서비스를 제공합니다.</p>
                                <span className="img-box">
                                    <img src="./img/Introduction1_img_3.svg" alt="" />
                                </span>
                            </li>
                        </ul>
                    </div>
                </RightBox>
            </div>
        </Wrap>
    );
}

export default Introduction1;

const Wrap = styled.div`
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 100px 0;
    @media (max-width: 1400px) {
        padding: 7.1428vw 0;
    }
    @media (max-width: 767px) {
        padding: 50px 0;
    }

    .con {
        @media (max-width: 1920px) {
            position: static;
        }
        @media (max-width: 767px) {
            flex-direction: column;
            gap: 24px;
        }
    }

    .bg-img-1 {
        width: 743px;
        top: 52px;
        left: -256px;
        @media (max-width: 1920px) {
            top: 152px;
            left: -36px;
        }
        @media (max-width: 1400px) {
            width: 53.0714vw;
            top: 10.8571vw;
            left: -2.5714vw;
        }
        @media (max-width: 767px) {
            width: 227px;
            top: 15px;
            left: -11px;
        }
    }

    .bg-img-2 {
        width: 979px;
        bottom: 13px;
        right: -279px;
        @media (max-width: 1920px) {
            bottom: 113px;
            right: -59px;
        }
        @media (max-width: 1400px) {
            width: 69.9285vw;
            bottom: 8.0714vw;
            right: -4.2142vw;
        }
        @media (max-width: 767px) {
            width: 299px;
            bottom: auto;
            top: 180px;
            right: -17px;
        }
    }
`
const LeftBox = styled.div`
    @media (max-width: 767px) {
        text-align: center;
    }

    > h1 {
        font-size: 48px;
        line-height: 56px;
        color: #282828;
        @media (max-width: 1400px) {
            font-size: 3.4285vw;
            line-height: 4vw;
        }
        @media (max-width: 767px) {
            font-size: 30px;
            line-height: 40px;
        }
        span {
            line-height: 56px;
            color: ${props => props.theme.mainColor1};
            @media (max-width: 1400px) {
                line-height: 4vw;
            }
            @media (max-width: 767px) {
                line-height: 40px;
            }
        }
    }

    > p {
        margin-top: 24px;
        font-size: 24px;
        line-height: 28px;
        color: #282828;
        @media (max-width: 1400px) {
            margin-top: 1.7142vw;
            font-size: 1.7142vw;
            line-height: 2vw;
        }
        @media (max-width: 767px) {
            margin-top: 12px;
            font-size: 17px;
            line-height: 28px;
        }
    }
`
const RightBox = styled.div`
    .list-box {
        gap: 24px;
        @media (max-width: 1400px) {
            gap: 1.7142vw;
        }
        @media (max-width: 767px) {
            flex-direction: column;
            gap: 12px;
        }

        > ul {
            gap: 24px;
            width: 332px;
            @media (max-width: 1400px) {
                gap: 1.7142vw;
                width: 23.7142vw;
            }
            @media (max-width: 767px) {
                gap: 12px;
                width: 100%;
            }

            > li {
                height: 407px;
                box-sizing: border-box;
                width: 100%;
                padding: 36px;
                border-radius: 20px;
                box-shadow: 4px 4px 30px 2px rgba(0, 0, 0, 0.05);
                &.list-1 {
                    background: linear-gradient(135deg, #E1E1E1, #C3EDB5);
                }
                &.list-2 {
                    background: linear-gradient(135deg, #D6CDFF, #FFD3BA);
                }
                &.list-3 {
                    background: linear-gradient(135deg, #ABC9FF, #FFD3BA);
                }
                @media (max-width: 1400px) {
                    height: 29.0714vw;
                    padding: 2.5714vw;
                    border-radius: 1.4285vw;
                    box-shadow: 0.2857vw 0.2857vw 2.1428vw 0.1428vw rgba(0, 0, 0, 0.05);
                }
                @media (max-width: 767px) {
                    height: auto;
                    width: 100%;
                    padding: 20px;
                    border-radius: 20px;
                    box-shadow: 4px 4px 30px 2px rgba(0, 0, 0, 0.05);
                }

                > h3 {
                    font-size: 30px;
                    line-height: 40px;
                    color: #181818;
                    @media (max-width: 1400px) {
                        font-size: 2.1428vw;
                        line-height: 2.8571vw;
                    }
                    @media (max-width: 767px) {
                        font-size: 24px;
                        line-height: 32px;
                    }
                }

                > p {
                    margin-top: 20px;
                    font-size: 22px;
                    line-height: 28px;
                    color: #525252;
                    @media (max-width: 1400px) {
                        margin-top: 1.4285vw;
                        font-size: 1.5714vw;
                        line-height: 2vw;
                    }
                    @media (max-width: 767px) {
                        margin-top: 20px;
                        font-size: 18px;
                        line-height: 28px;
                    }
                }

                > .img-box {
                    margin-top: 56px;
                    width: 100%;
                    @media (max-width: 1400px) {    
                        margin-top: 4vw;
                    }
                    @media (max-width: 767px) {
                        margin-top: 24px;
                        margin-left: auto;
                        margin-right: 0;
                        width: 85%;
                    }
                }
            }
        }
    }
`